module.exports = __webpack_public_path__ + "static/media/sidebar.f9036e5c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/sidebar.png
// module id = 460
// module chunks = 1